module.exports = __webpack_public_path__ + "static/media/beach_small.a0a019b6.jpg";